import lang from 'lang'
import settingsConfig from '@/modules/settings/config'
import request from '@/modules/base/util/request'

import { toast } from '@/modules/base/components/toast/toastConfig'

const ACTION_PREFIX = 'settings/taxAccountant'
const SET_TAX_ACCOUNTANT_DETAIL = `${ACTION_PREFIX}/SET_TAX_ACCOUNTANT_DETAIL`

const initialState = {
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_TAX_ACCOUNTANT_DETAIL:
      const { data } = action
      return { ...state, ...data }

    default:
      return state
  }
}

export const setTaxAccountantData = (data) => {
  return {
    type: SET_TAX_ACCOUNTANT_DETAIL,
    data,
  }
}

export const fetchTaxAccountantData = () => {
  return dispatch => {
    request(settingsConfig.taxAccountantSettings, { auth: true, isConcurrent: true })
      .then(({ body: { data } }) => {
        dispatch(setTaxAccountantData(data))
      })
      .catch(() => toast.showToast({ type: 'error', message: lang.defaultErrorMessage }))
      .done()
  }
}
